var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
import { jsx as _jsx } from "react/jsx-runtime";
import { useLocation } from 'react-router-dom';
import React, { createContext, useCallback, useContext, useEffect, useMemo, useState, } from 'react';
import pkg from '../../../package.json';
var INITIAL_STATE = {
    isFixed: true,
    isExpanded: true,
    loaded: false,
    isNativeApp: false,
    version: '1.0.0',
    hideIOS: true,
    platformOs: 'web',
    platformVersion: '1.0.0',
    setIsFixed: function () { },
    setIsExpanded: function () { },
};
var AppStateContext = createContext(INITIAL_STATE);
export var AppStateProvider = function (_a) {
    var children = _a.children;
    var _b = __read(useState(true), 2), isFixed = _b[0], setIsFixed = _b[1];
    var _c = __read(useState(true), 2), isExpanded = _c[0], setIsExpanded = _c[1];
    var _d = __read(useState(false), 2), isNativeApp = _d[0], setIsNativeApp = _d[1];
    var _e = __read(useState('web'), 2), platformOs = _e[0], setPlatformOs = _e[1];
    var _f = __read(useState('1.0.0'), 2), platformVersion = _f[0], setPlatformVersion = _f[1];
    var pathname = useLocation().pathname;
    useEffect(function () {
        if (!isExpanded) {
            return;
        }
        setIsExpanded(false);
    }, [pathname]);
    var manageOsAndVersion = useCallback(function () {
        if (typeof window === 'undefined') {
            return;
        }
        var windowNativeApp = window.isNativeApp;
        var windowPlatformOs = window.platformOs;
        var windowPlatformVersion = window.platformVersion;
        var localStorageIsNativeApp = localStorage.getItem('isNativeApp');
        var isNativeApp = windowNativeApp ||
            (!!localStorageIsNativeApp && localStorageIsNativeApp === 'true');
        if (isNativeApp) {
            setPlatformOs(windowPlatformOs);
            setPlatformVersion(windowPlatformVersion);
        }
        setIsNativeApp(isNativeApp);
    }, []);
    useEffect(function () {
        manageOsAndVersion();
    }, [manageOsAndVersion]);
    var values = useMemo(function () { return ({
        isFixed: isFixed,
        isExpanded: isExpanded,
        isNativeApp: isNativeApp,
        platformOs: platformOs,
        platformVersion: platformVersion,
        version: pkg.version,
        hideIOS: true,
        setIsFixed: setIsFixed,
        setIsExpanded: setIsExpanded,
    }); }, [isFixed, isExpanded, isNativeApp, platformOs, platformVersion]);
    return (_jsx(AppStateContext.Provider, __assign({ value: values }, { children: children }), void 0));
};
export var useAppState = function () {
    var context = useContext(AppStateContext);
    if (context === undefined) {
        throw new Error('useAppState hook must be used within a AppStateProvider');
    }
    return context;
};
